import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {StatusMessage} from "../model/status-message";

@Injectable({
  providedIn: 'root'
})
export class StatusMessageService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Retrieves all status messages for a specific referenceId
   *
   * @param referenceId Id for which all status messages should be retrieved
   * @param options HttpOptions
   * @returns Observable containing an array of all retrieved status messages
   */
  public getStatusMessagesByReferenceId(referenceId: string, options = {}): Observable<StatusMessage[]>{
    return this.httpClient.get<StatusMessage[]>("/api/status-messages/" + referenceId, options);
  }

}
